import Vue from 'vue';
import VueCountdown from '@xkeshi/vue-countdown';

Vue.component(VueCountdown.name, VueCountdown);

new Vue({
    el: '#app',

    data: {
        filterActive: false
    }
});

jQuery(document).ready(function () {

    /*
     * Pagination
     */
    jQuery(document).on('click', '.pagination a:not(".disabled")', function (e) {
        let href = jQuery(this).attr('href');

        jQuery('form').request('onGetProducts', {
            loading: jQuery.oc.stripeLoadIndicator,
            data: {page: href.split('page=')[1]},
            complete: function () {
                history.replaceState(null, '', href);

                // window.scrollTo({
                //     top: jQuery('.row_products').offset().top,
                //     behavior: 'smooth',
                // });
            }
        });

        e.preventDefault();
    });

    /*
     * Change filters
     */
    jQuery(document).on('change', '.products_filter', function (e) {
        jQuery('form').request('onGetProducts', {
            loading: jQuery.oc.stripeLoadIndicator,
            data: {page: 1},
            complete: function (response) {
                history.replaceState(null, '', '?' + response.responseJSON.query);
            }
        });

        e.preventDefault();
    });

    /*
     * Search
     */
    function delay(callback, ms) {
        var timer = 0;
        return function () {
            var context = this, args = arguments;
            clearTimeout(timer);
            timer = setTimeout(function () {
                callback.apply(context, args);
            }, ms || 0);
        };
    }

    jQuery(document).on('keyup', '.filters__input_search', delay(function (e) {
        onSearch();
        e.preventDefault();
    }, 300));

    jQuery(document).on('keyup', '.dry-products__filter__search', delay(function (e) {
        onSearch();
        e.preventDefault();
    }, 300));

    function onSearch() {
        jQuery('form').request('onGetProducts', {
            loading: jQuery.oc.stripeLoadIndicator,
            data: {page: 1},
            complete: function (response) {
                history.replaceState(null, '', '?' + response.responseJSON.query);
            }
        });
    }

    /*
     *  Select2 Dropdowns
     */
    jQuery('.sort_by_dates, .pagination_limit').select2({
        minimumResultsForSearch: 5
    });


    /*
     * Price Slider
     */
    if (jQuery('#slider').length) {
        jQuery('#slider').slider({
            tooltip: 'always'
        }).on('slideStop', function (slider) {
            jQuery('form').request('onGetProducts', {
                loading: jQuery.oc.stripeLoadIndicator,
                data: {page: 1, price: slider.value.newValue},
                complete: function (response) {
                    history.replaceState(null, '', '?' + response.responseJSON.query);
                }
            });
        });
    }

    /*
     * Favourite filter
     */
    jQuery(document).on('click', '#favoriteToggle', function (e) {

        var container = this;
        // TODO: implement better logic
        var favouritesVal = jQuery('#favourites').val();

        jQuery('form').request('onGetProducts', {
            loading: jQuery.oc.stripeLoadIndicator,
            data: {page: 1,requestFavourites:true},
            complete: function (response) {
                // TODO: implement better logic
                if(favouritesVal == 'disable'){
                    jQuery('#favourites').val('enable');
                    jQuery(container).html('<span class="tooltip__text">Toggle Favourites</span><i class="far fa-star"></i>');
                }else{
                    jQuery('#favourites').val('disable');
                    jQuery(container).html('<span class="tooltip__text">Toggle Favourites</span><i class="fas fa-star text-blue-600"></i>');
                }
            }
        });

        e.preventDefault();
    });

    /*
     * Add Favourite
     */
    jQuery(document).on('click', '.on_add_favourite', function (e) {
        var container = this;
        var requestData = jQuery(this).data('request-data');
        jQuery('user-add-favourites').request('onAddFavourite', {
            loading: jQuery.oc.stripeLoadIndicator,
            data: {product: requestData},
            complete: function (response) {
                    jQuery(container).removeClass('on_add_favourite');
                    jQuery(container).addClass('products-list__favorite--active');
                    jQuery(container).addClass('on_remove_favourite');
                    jQuery(container).html('<span class="tooltip__text">Remove from Favourites</span><i class="fas fa-star text-blue-600"></i>');
            }
        });

        e.preventDefault();
    });

    /*
     * Remove Favourite
     */
    jQuery(document).on('click', '.on_remove_favourite', function (e) {
        var container = this;
        var requestData = jQuery(this).data('request-data');
        jQuery('user-remove-favourites').request('onRemoveFavourite', {
            loading: jQuery.oc.stripeLoadIndicator,
            data: {product: requestData},
            complete: function (response) {
                jQuery(container).removeClass('on_remove_favourite');
                jQuery(container).removeClass('products-list__favorite--active');
                jQuery(container).addClass('on_add_favourite');
                jQuery(container).html('<span class="tooltip__text">Add to Favourites</span><i class="far fa-star"></i>');
            }
        });

        e.preventDefault();
    });

});



// WEBPACK FOOTER //
// ./plugins/renatio/shop/assets/js/products.js